import ts from 'typescript';
import * as utils from './utils';
export function getNamedExports(node) {
    const namedExports = utils.getValueOrUndefined(node.exportClause);
    if (namedExports === undefined) {
        return [];
    }
    const exps = !ts.isNamedExports(namedExports) ? undefined : utils.getValueOrUndefined(namedExports.elements);
    return exps === undefined ? [] : exps;
}

//# sourceMappingURL=exportDeclaration.js.map
